export default __webpack_public_path__ + "static/media/JASARI_Slogan.29ba2e0d.webp";